module.exports = __webpack_public_path__ + "img/猫窝-1.93981190.jpg";